import BackendService from 'BackendService';
import { useEffect, useState } from 'react';

// One question per page load: the deployment's setting cannot change without a redeploy.
let availability: Promise<boolean> | null = null;

export function resetLogCaptureAvailability(): void {
  availability = null;
}

/**
 * Whether this deployment allows client log capture (backend CLIENT_LOG_CAPTURE_ENABLED). False
 * until the backend says otherwise, so nothing log-related flashes up where it is off.
 */
export function useLogCaptureAvailable(): boolean {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let mounted = true;
    // Any failure, even a synchronous throw, means "off": the feature must never appear by error.
    availability ??= Promise.resolve()
      .then(() => new BackendService().getLogCaptureAvailable())
      .catch(() => false);
    void availability.then((value) => {
      if (mounted) setAvailable(value);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return available;
}
